import { render, staticRenderFns } from "./Aggregate.vue?vue&type=template&id=29c6a304&scoped=true&"
import script from "./Aggregate.vue?vue&type=script&lang=js&"
export * from "./Aggregate.vue?vue&type=script&lang=js&"
import style0 from "./Aggregate.vue?vue&type=style&index=0&id=29c6a304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c6a304",
  null
  
)

export default component.exports